
export default function WhyChooseSection() {
  const features = [
    {
      icon: 'ri-award-line',
      title: 'QCDD Approved',
      description: 'All our systems and services meet Qatar Civil Defence Department standards.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Experienced Engineers',
      description: 'Our certified team brings years of expertise in fire safety solutions.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Comprehensive Solutions',
      description: 'From design to maintenance, we handle all aspects of fire protection.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Fast Support Response',
      description: '24/7 maintenance support to ensure your systems are always operational.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose FlameGuardQA?</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We combine technical expertise, regulatory compliance, and reliable service 
            to deliver fire safety solutions you can trust.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full mx-auto mb-4">
                <i className={`${feature.icon} text-2xl text-red-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Trusted by Leading Organizations Across Qatar
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              From commercial buildings to industrial facilities, we've successfully implemented 
              fire safety solutions for diverse sectors including healthcare, education, 
              hospitality, and manufacturing.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-red-600 mb-2">500+</div>
                <p className="text-gray-600">Projects Completed</p>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-red-600 mb-2">15+</div>
                <p className="text-gray-600">Years Experience</p>
              </div>
            </div>
          </div>
          <div>
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20fire%20safety%20equipment%20installation%20in%20Qatar%20commercial%20building%2C%20fire%20sprinkler%20system%20and%20alarm%20panels%20being%20installed%20by%20certified%20technicians%2C%20modern%20safety%20infrastructure%20with%20red%20safety%20equipment%20and%20QCDD%20compliance%20certificates&width=600&height=400&seq=why-choose&orientation=landscape"
              alt="Fire Safety Installation"
              className="rounded-2xl shadow-xl object-cover w-full h-80"
            />
          </div>
        </div>
      </div>
    </section>
  );
}